<template>
  <div id="pageAdminWrapper">
    <loading-notification
      v-if="!page || !table"
      message="Het rapport wordt geladen...">
    </loading-notification>

    <template v-else>
      <h1 class="title">{{ page.name }}</h1>

      <div class="field">
        <label>Naam contentpagina</label>
        <div class="control">
          <input name="name" class="input" type="text" v-model="name">
        </div>
      </div>

      <div class="field">
        <div class="control">
          <label class="radio">
            <input type="radio" name="viewMode" v-model="viewMode" value="grid">
            Grid
          </label>

          <label class="radio">
            <input type="radio" name="viewMode" v-model="viewMode" value="tree">
            Boom
          </label>
        </div>
      </div>

      <hr>

      <div class="columns">
        <div class="column">
          <nav class="panel">
            <p class="panel-heading">Beschikbare kolommen</p>

            <a v-for="columnId in available" :key="columnId" class="panel-block" @click="toggle(columnId)">
              <span class="panel-icon is-pulled-right">
                <i class="fas fa-plus" aria-hidden="true"></i>
              </span>
              {{ getColumnName(columnId) }}
            </a>
          </nav>
        </div>

        <div class="column">
          <nav class="panel">
            <p class="panel-heading">Geselecteerde kolommen</p>

            <draggable v-model="included" @start="drag=true" @end="drag=false">
              <a v-for="columnId in included" :key="columnId" class="panel-block" @click="toggle(columnId)">
                <span class="panel-icon is-pulled-right">
                  <i class="fas fa-minus" aria-hidden="true"></i>
                </span>
                {{ getColumnName(columnId) }}
              </a>
            </draggable>
          </nav>
        </div>
      </div>

      <save-buttons
        @save="save"
        @cancel="close">
      </save-buttons>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Draggable from 'vuedraggable'
import SaveButtons from '@/components/modules/SaveButtons'
import LoadingNotification from '@/components/modules/LoadingNotification'

export default {
  components: {
    Draggable,
    SaveButtons,
    LoadingNotification
  },
  data () {
    return {
      name: null,
      included: [],
      available: [],
      viewMode: 'grid'
    }
  },
  computed: {
    ...mapGetters({
      page: 'pages/page',
      table: 'tables/table',
      columns: 'columns/columns'
    })
  },
  created () {
    this.$store.dispatch('pages/loadAdmin', {
      id: this.$route.params.id
    })

    this.$store.dispatch('tables/loadForAdmin', {
      id: this.$route.params.tableId
    })
  },
  watch: {
    page () {
      if (this.page) {
        this.name = this.page.name
        this.viewMode = this.page.view_mode
      }
    },
    table () {
      if (this.table && this.page) {
        this.loadColumns()
      }
    }
  },
  methods: {
    getColumnName (columnId) {
      return this.columns.find(x => x.id === columnId).tabname
    },
    loadColumns () {
      this.included = this.page.columns.map(columnId => columnId)
      this.available = this.table.column_ids.filter(columnId => !this.included.includes(columnId))
    },
    toggle (columnId) {
      if (this.included.includes(columnId)) {
        this.included.splice(this.included.findIndex(x => x === columnId), 1)
        this.available.push(columnId)
      } else {
        this.available.splice(this.available.findIndex(x => x === columnId), 1)
        this.included.push(columnId)
      }
    },
    save () {
      this.$store.dispatch('pages/save', {
        name: this.name,
        id: this.page.id,
        columns: this.included,
        view_mode: this.viewMode,
        table_id: this.page.table_id
      })

      this.close()
    },
    close () {
      this.$router.push({ name: 'pages-admin', params: { tableId: this.page.table_id } })
    }
  }
}
</script>
